/**
 * @description: 律师状态
 */
export enum LawyerStateEnum {
  LAWYER_STATE_NORMAL = 1, // 正常
  LAWYER_STATE_STOP = 2 // 停用
}
